import { useEffect, useMemo } from 'react'
import { useLogError } from '@/src/common/hooks/useLogError'
import {
  StateMappingSchema,
  useMortgageModuleWebviewFlowParameterStore,
} from '../statsig/store/useMortgageModuleWebviewFlowParameterStore'
import { useStatsigLoadingStatus } from '@/src/services/Statsig'

export function useMortgageModuleWebviewFlow() {
  const loadingStatus = useStatsigLoadingStatus()
  const mortgageModuleWebviewFlowParameterStore = useMortgageModuleWebviewFlowParameterStore()
  const logError = useLogError()

  const result = useMemo(() => {
    try {
      const stateMappingParameter = mortgageModuleWebviewFlowParameterStore.get('state_mapping')

      switch (loadingStatus) {
        case 'Uninitialized':
        case 'Loading':
          return 'loading'
      }

      return StateMappingSchema.safeParse(stateMappingParameter)
    } catch (error) {
      return {
        error:
          error instanceof Error
            ? error
            : new Error('Failed to obtain parameter mortgage_module_webview_flow'),
      } as const
    }
  }, [mortgageModuleWebviewFlowParameterStore, loadingStatus])

  useEffect(() => {
    if (result !== 'loading' && 'error' in result) {
      logError(
        result.error ?? new Error('Failed to obtain parameter mortgage_module with unknown error'),
        {
          cause: result,
        },
      )
    }
  }, [logError, result])

  if (result === 'loading') {
    return 'loading'
  }

  if ('error' in result) {
    return 'error'
  }

  return result.data
}
